/**
 * Kurztitel der Anträge eines Projekts – so stehen sie in der Navigation.
 *
 * Grundlage ist der Kurzname der Antragsart („Vollgenehmigung"); der volle Name ist der
 * ELiA-Wortlaut und passt nicht in die Sidebar. Fehlt der Kurzname, steht der volle Name da
 * und wird von der Sidebar gekürzt.
 *
 * Hat ein Projekt dieselbe Antragsart mehrfach, bekommen die weiteren eine Nummer in der
 * Reihenfolge der Liste: „Vollgenehmigung", „Vollgenehmigung (2)".
 */
import { PermitProcedure } from "../types";

export const antragKurztitel = (
  procedures: PermitProcedure[],
): Map<string, string> => {
  const bisherigeJeTitel = new Map<string, number>();
  const titel = new Map<string, string>();
  for (const procedure of procedures) {
    const basis =
      procedure.procedure_type.kurzname || procedure.procedure_type.name;
    const anzahl = (bisherigeJeTitel.get(basis) ?? 0) + 1;
    bisherigeJeTitel.set(basis, anzahl);
    titel.set(procedure.id, anzahl === 1 ? basis : `${basis} (${anzahl})`);
  }
  return titel;
};
